export const SEARCH_STATUS_CURRENT_TIME_DELAY: number = 60000;

export const SEARCH_STATUS_PENDING_MAX_DELAY: number = 300000;
